import { render, staticRenderFns } from "./changeHub.vue?vue&type=template&id=3efc423d&scoped=true"
import script from "./changeHub.vue?vue&type=script&lang=js"
export * from "./changeHub.vue?vue&type=script&lang=js"
import style0 from "./changeHub.vue?vue&type=style&index=0&id=3efc423d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efc423d",
  null
  
)

export default component.exports